import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { style: {"padding-top":"130px"} }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: "pr-1 flex-grow-1" }
const _hoisted_7 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }
const _hoisted_8 = { class: "pr-1" }
const _hoisted_9 = { class: "pr-1" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "navbar navbar-expand-lg navbar-light bg-light"
}
const _hoisted_12 = {
  class: "collapse navbar-collapse",
  id: "ProjectsTpl_NavigationBar"
}
const _hoisted_13 = { class: "navbar-nav" }
const _hoisted_14 = { class: "nav-item dropdown" }
const _hoisted_15 = {
  class: "nav-link dropdown-toggle",
  href: "#",
  "data-toggle": "dropdown"
}
const _hoisted_16 = {
  key: 0,
  class: "fa fa-sort-alpha-asc"
}
const _hoisted_17 = {
  key: 1,
  class: "fa fa-sort-alpha-desc"
}
const _hoisted_18 = { class: "dropdown-menu" }
const _hoisted_19 = {
  class: "form-inline my-2 my-lg-0 ml-2",
  role: "search"
}
const _hoisted_20 = { class: "input-group input-group-sm" }
const _hoisted_21 = { style: {"padding-bottom":"50px","margin-top":"20px"} }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = {
  class: "tile bg-color-gray5",
  style: {"margin-bottom":"20px","padding":"8px"}
}
const _hoisted_24 = { class: "dropdown float-right" }
const _hoisted_25 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_26 = { class: "dropdown-item" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  class: "text-ellipsis font-weight-light",
  style: {"margin-top":"7px"}
}
const _hoisted_33 = { class: "text-dark" }
const _hoisted_34 = { class: "text-ellipsis fg-color-gray1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DecisionProjectBuilder = _resolveComponent("DecisionProjectBuilder")!
  const _component_PortfolioProjectBuilder = _resolveComponent("PortfolioProjectBuilder")!
  const _component_ProjectCloner = _resolveComponent("ProjectCloner")!
  const _component_ProjectEditor = _resolveComponent("ProjectEditor")!
  const _component_ProjectTemplateLinksManager = _resolveComponent("ProjectTemplateLinksManager")!
  const _component_ProjectWorkspaceSwitcher = _resolveComponent("ProjectWorkspaceSwitcher")!
  const _component_WorkspaceNavigation = _resolveComponent("WorkspaceNavigation")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DecisionProjectBuilder, {
      viewModel: _ctx.decisionProjectBuilder,
      onCreateDecision: _ctx.handleCreateDecisionProjectCommand
    }, null, 8 /* PROPS */, ["viewModel", "onCreateDecision"]),
    _createVNode(_component_PortfolioProjectBuilder, {
      viewModel: _ctx.portfolioProjectBuilder,
      onCreatePortfolio: _ctx.handleCreatePortfolioProjectCommand
    }, null, 8 /* PROPS */, ["viewModel", "onCreatePortfolio"]),
    _createVNode(_component_ProjectCloner, {
      viewModel: _ctx.projectCloner,
      onCloneProject: _ctx.handleCloneProjectCommand
    }, null, 8 /* PROPS */, ["viewModel", "onCloneProject"]),
    _createVNode(_component_ProjectEditor, {
      viewModel: _ctx.projectEditor,
      onUpdateProject: _ctx.handleUpdateProjectCommand,
      onDeleteProject: _ctx.handleDeleteProjectCommand
    }, null, 8 /* PROPS */, ["viewModel", "onUpdateProject", "onDeleteProject"]),
    _createVNode(_component_ProjectTemplateLinksManager, {
      viewModel: _ctx.projectTemplateLinksManager,
      onUpdateLinks: _ctx.handleUpdateProjectTemplateLinksCommand
    }, null, 8 /* PROPS */, ["viewModel", "onUpdateLinks"]),
    (_ctx.projectWorkspaceSwitcher)
      ? (_openBlock(), _createBlock(_component_ProjectWorkspaceSwitcher, {
          key: 0,
          viewModel: _ctx.projectWorkspaceSwitcher,
          onMoveProject: _ctx.handleSwitchProjectWorkspaceCommand
        }, null, 8 /* PROPS */, ["viewModel", "onMoveProject"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_WorkspaceNavigation, {
        workspaceId: _ctx.workspaceId,
        workspaceName: _ctx.workspaceName
      }, null, 8 /* PROPS */, ["workspaceId", "workspaceName"]),
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.initialized)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_3, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
              _createTextVNode(" Loading... ", -1 /* CACHED */)
            ]))]))
          : _createCommentVNode("v-if", true),
        (_ctx.initialized)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.workspaceName), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "btn btn-success",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showPortfolioBuilder && _ctx.showPortfolioBuilder(...args)))
                  }, " Create Portfolio ")
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    class: "btn btn-secondary",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showDecisionBuilder && _ctx.showDecisionBuilder(...args)))
                  }, " Make Decision ")
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "pr-1" }, [
                  _createElementVNode("a", {
                    class: "btn btn-outline-secondary",
                    href: "https://www.transparentchoice.com/user-guide/getting-started",
                    title: "User guide: Getting started",
                    target: "_blank"
                  }, [
                    _createElementVNode("i", {
                      class: "fa fa-info",
                      "aria-hidden": "true"
                    })
                  ])
                ], -1 /* CACHED */))
              ]),
              _cache[15] || (_cache[15] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
              (_ctx.projects.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("p", { class: "lead" }, "You don't have any projects yet.", -1 /* CACHED */)
                  ]))]))
                : _createCommentVNode("v-if", true),
              (_ctx.projects.length > 0)
                ? (_openBlock(), _createElementBlock("nav", _hoisted_11, [
                    _cache[10] || (_cache[10] = _createElementVNode("button", {
                      class: "navbar-toggler",
                      type: "button",
                      "data-toggle": "collapse",
                      "data-target": "#ProjectsTpl_NavigationBar",
                      "aria-expanded": "false",
                      "aria-label": "Toggle navigation"
                    }, [
                      _createElementVNode("span", { class: "navbar-toggler-icon" })
                    ], -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("ul", _hoisted_13, [
                        _createElementVNode("li", _hoisted_14, [
                          _createElementVNode("a", _hoisted_15, [
                            _createTextVNode(" Order by " + _toDisplayString(_ctx.orderBy) + " ", 1 /* TEXT */),
                            (!_ctx.orderByDescending)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                              : _createCommentVNode("v-if", true),
                            (_ctx.orderByDescending)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_17))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.orderByName && _ctx.orderByName(...args)))
                            }, "Name"),
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.orderByCreated && _ctx.orderByCreated(...args)))
                            }, "Date of creation"),
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.orderByLastActivity && _ctx.orderByLastActivity(...args)))
                            }, "Last activity")
                          ])
                        ])
                      ]),
                      _createElementVNode("form", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchPhrase) = $event)),
                            class: "form-control form-control-sm",
                            type: "search",
                            placeholder: "Search"
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, _ctx.searchPhrase]
                          ]),
                          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "input-group-append" }, [
                            _createElementVNode("span", { class: "input-group-text" }, [
                              _createElementVNode("i", {
                                class: "fa-solid fa-magnifying-glass",
                                "aria-hidden": "true"
                              })
                            ])
                          ], -1 /* CACHED */))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectsView, (p) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-md-4 col-sm-6",
                      key: p.ProjectId
                    }, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _cache[14] || (_cache[14] = _createElementVNode("a", {
                            "data-toggle": "dropdown",
                            class: "text-dark"
                          }, [
                            _createElementVNode("i", { class: "fa fa-ellipsis-h" })
                          ], -1 /* CACHED */)),
                          _createElementVNode("div", _hoisted_25, [
                            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_26, [...(_cache[11] || (_cache[11] = [
                              _createTextVNode("Open", -1 /* CACHED */)
                            ]))])), [
                              [_directive_sanitizedHref, `/#/project/${p.ProjectId}`]
                            ]),
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              onClick: ($event: any) => (_ctx.showProjectEditor(p))
                            }, "Edit or delete", 8 /* PROPS */, _hoisted_27),
                            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              onClick: ($event: any) => (_ctx.showProjectCloner(p))
                            }, "Clone", 8 /* PROPS */, _hoisted_28),
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              onClick: ($event: any) => (_ctx.showProjectTemplateLinksManager(p))
                            }, "Share as a template", 8 /* PROPS */, _hoisted_29),
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              onClick: ($event: any) => (_ctx.showProjectWorkspaceSwitcher(p))
                            }, "Move to a workspace", 8 /* PROPS */, _hoisted_30),
                            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              onClick: ($event: any) => (_ctx.exportToJson(p))
                            }, "Export to JSON", 8 /* PROPS */, _hoisted_31)
                          ])
                        ]),
                        _createElementVNode("h5", _hoisted_32, [
                          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_33, [
                            _createTextVNode(_toDisplayString(p.Name), 1 /* TEXT */)
                          ])), [
                            [_directive_sanitizedHref, `/#/project/${p.ProjectId}`]
                          ])
                        ]),
                        _createElementVNode("p", _hoisted_34, _toDisplayString(p.Description) + "   ", 1 /* TEXT */)
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}